import { useCallback, useState, useRef } from 'react'
import { useResend } from 'streamr-client-react'
import useIsMounted from './useIsMounted'

const useLastMessageTimestamp = (streamId) => {
    const [{ timestamp, error, refreshedAt, refreshKey }, setState] = useState({
        error: undefined,
        refreshedAt: undefined,
        refreshKey: 0,
        timestamp: undefined,
    })

    const isMounted = useIsMounted()

    const isFetchingRef = useRef(true)

    const refresh = useCallback(() => {
        // Skip updating `refreshKey` if we're already
        // in "fetching" mode.
        if (!isFetchingRef.current) {
            setState((c) => ({
                ...c,
                refreshKey: c.refreshKey + 1,
                error: undefined,
            }))

            isFetchingRef.current = true
        }
    }, [])

    useResend(streamId, {
        last: 1,
    }, {
        cacheKey: refreshKey,
        onMessage(msg) {
            if (!isMounted()) {
                return
            }

            setState((c) => ({
                ...c,
                timestamp: msg?.messageId?.timestamp,
                refreshedAt: new Date().getTime(),
            }))
        },
        onError(e) {
            if (!isMounted()) {
                return
            }

            setState((c) => ({
                ...c,
                error: e,
            }))
        },
        onAfterFinish() {
            isFetchingRef.current = false
        },
    })

    return [timestamp, error, refresh, refreshedAt]
}

export default useLastMessageTimestamp
